export default __webpack_public_path__ + "static/media/testimonial-6.952b9701.webp";